import CitySEOHead from "@/components/feature/CitySEOHead";
import CelebrationHeroSection from "./components/HeroSection";
import CelebrationStickyNav from "./components/StickyNav";
import CelebrationProcessingTimeSection from "./components/ProcessingTimeSection";
import CelebrationServicesSection from "./components/ServicesSection";
import CelebrationLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import CelebrationTravelTimingSection from "./components/TravelTimingSection";
import CelebrationDestinationsSection from "./components/DestinationsSection";
import CelebrationTestimonialsSection from "./components/TestimonialsSection";
import CelebrationAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CelebrationComparisonSection from "./components/ComparisonSection";
import CelebrationMistakesSection from "./components/MistakesSection";
import CelebrationHowItWorksSection from "./components/HowItWorksSection";
import CelebrationFAQSection, { faqs } from "./components/FAQSection";
import CelebrationHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CelebrationFinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Celebration, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Celebration, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Osceola County Disney travelers, families, and medical professionals.";

const areaServedList = [
  { "@type": "City", name: "Celebration" },
  { "@type": "City", name: "Kissimmee" },
  { "@type": "City", name: "Walt Disney World" },
  { "@type": "City", name: "Lake Buena Vista" },
  { "@type": "City", name: "Davenport" },
  { "@type": "City", name: "ChampionsGate" },
  { "@type": "City", name: "Reunion" },
  { "@type": "AdministrativeArea", name: "Osceola County" },
];

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CelebrationPage() {
  return (
    <>
      <CitySEOHead
        city="Celebration"
        state="Florida"
        stateAbbr="FL"
        route="/celebration"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Celebration, Florida"
        geoPosition="28.3135;-81.5437"
        keywords="expedited passport Celebration, emergency passport Celebration FL, same day passport Celebration, fast passport Florida, passport renewal Celebration, Osceola County passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc="Fast Passport Center does not have a physical office in Celebration — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Celebration and Osceola County travelers."
        landmarks={landmarks}
      />

      <div className="font-sans">
      <CelebrationHeroSection />
      <CelebrationStickyNav />
      <CelebrationProcessingTimeSection />
      <CelebrationLocalAreaSection />
      <CelebrationServicesSection />
      <CelebrationTravelTimingSection />
      <CelebrationDestinationsSection />
      <CelebrationTestimonialsSection />
      <CelebrationAcceptanceFacilitiesSection />
      <CelebrationComparisonSection />
      <CelebrationMistakesSection />
      <CelebrationHowItWorksSection />
      <CelebrationFAQSection />
      <CelebrationHelpfulResourcesSection />
      <CelebrationFinalCTA />
      </div>
    </>
  );
}